module.exports = __webpack_public_path__ + "media/images/mamari/wowma/about-wowma-99aa63052df7908ed24f23a1c0522d90.png";